export default "__VITE_ASSET__DjubwdQ8__"